import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t, direction } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Trust Strip */}
      <div className="bg-gradient-to-r from-green-600 to-green-500 text-white py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left">
            <div>
              <p className="font-semibold text-lg">Built in Saudi Arabia</p>
              <p className="text-sm opacity-90" dir="rtl">مصنوع في السعودية</p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white opacity-30"></div>
            <div>
              <p className="font-semibold text-lg">Aligned with Vision 2030</p>
              <p className="text-sm opacity-90" dir="rtl">متوافق مع رؤية 2030</p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white opacity-30"></div>
            <div>
              <p className="font-semibold text-lg">Secure, compliant digital payments</p>
              <p className="text-sm opacity-90" dir="rtl">ومبني على مدفوعات رقمية امنة</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-gradient-to-br from-green-50 to-yellow-50 border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Tagline */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_a49fc96e-c6d1-4538-8241-3e5dffe114fb/artifacts/6uiz1cw4_WhatsApp%20Image%201447-06-18%20at%2008.46.59.jpeg"
                alt="ROYA"
                style={{
                  height: '48px',
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
            </div>
            <p className="text-gray-600 mb-2 text-lg font-medium" style={{ color: '#10B981' }}>
              {t('footer.tagline')}
            </p>
            <p className="text-gray-600 text-sm mb-3 leading-relaxed max-w-md">
              {t('footer.built')}
            </p>
            <p className="text-gray-500 text-xs leading-relaxed max-w-md">
              {t('footer.ecosystem')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">{t('nav.home')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/pos" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  {t('nav.posDevices')}
                </Link>
              </li>
              <li>
                <Link to="/wallet" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  {t('nav.wallet')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">{t('nav.about')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <span className="text-gray-600 text-sm">{t('contact.location')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 pt-6 text-center">
          <p className="text-gray-600 text-sm">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
